import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { Duration } from '@legacy-modules/dashboard/models/enums/Duration';

export enum ConfigurationKey {
  KpiOverview = 'dashboard.kpi_overview',
  DashboardTable = 'dashboard.table',
  DashboardChart = 'dashboard.chart',
  DashboardComponents = 'dashboard.components',
  RuecklaufTable = 'ruecklauf.table',
  KennzahlenTable = 'kennzahlen.table',
  HinweiseTable = 'hinweise.table',
  BeanstandungenTable = 'beanstandungen.table',
  TourenTable = 'touren.table',
  tourenTableAllgemein = 'touren.table.allgemein',
  tourenTableHTProduktivitaet = 'touren.table.htproduktivitaet',
  tourenTablePSProduktivitaet = 'touren.table.psproduktivitaet',
  tourenTableATGProduktivitaet = 'touren.table.atgproduktivitaet',
  tourenTableRuecklaufquote = 'touren.table.ruecklaufquote',
  tourenTableProduktivitaet = 'touren.table.produktivitaet',
}

export type ValueExpressionIdentifier = string;
export type EnrichedKpiTile = {
  identifier: string;
  valueExpression: ValueExpression;
};

export type KpiTab = {
  name: string;
  tiles: ValueExpressionIdentifier[];
};

export interface LegacyKpiOverviewConfig {
  duration: Duration;
  boxes?: ValueExpressionIdentifier[];
}

export interface KpiOverviewConfig {
  duration: Duration;
  tabs: KpiTab[];
}
